export default function () {
    function getUrl() {
        let url = `${$('base').attr('href')}index.php?route=product/search`;
        let search = $(' header input[name=\'search_desktop\']').val();

        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }

        return url;
    }

    let initElem = $('.catalog-search');

    if (initElem.length === 0) {
        return;
    }

    initElem.autocomplete({
        delay: 200,
        appendTo: '#autocomplete-results',
        source(request, response) {
            $.ajax({
                url: `index.php?route=search/autocomplete&filter_name=${encodeURIComponent(request.term)}`,
                dataType: 'json',
                success(json) {
                    response($.map(json.products, (item, index) => {
                        return {
                            label: item.name,
                            value: item.product_id,
                            href: item.href,
                            thumb: item.thumb,
                            desc: item.desc,
                            price: item.price,
                            special: item.special,
                            lastElem: json.products.length === index + 1 && json.products.length > 1,
                        };
                    }));
                },
            });
        },
        select(event, ui) {
            document.location.href = ui.item.href;

            return false;
        },
        focus() {
            return false;
        },
        minLength: 2,
    }).data('ui-autocomplete')._renderItem = function (ul, item) {
        let productPrice = item.special ?
            `<span class="price-old">${item.price}</span>&ensp;&ensp;<span class="price-new">${item.special}</span>` : item.price;

        let moreResult = item.lastElem ?
            '<span class="more-result">' +
                `<a class="more-result__link" href="${getUrl()}">Показать все результаты</a>` +
            '</span>' : '';

        return $('<li>').append(
            '<a href=\'javascript:void();\'>' +
                `<span class='img'><img src='${item.thumb}' alt=''></span>` +
                `<span class='description'>${item.label}</span>` +
                `<span class='price'>${productPrice}</span>` +
            `</a>${moreResult}`).appendTo(ul);
    };
}
